module.exports = __webpack_public_path__ + "img/4bc22f1682af6aaddbf3c6bc07edf91f.png";